import { render } from "./ProjectModel.vue?vue&type=template&id=b2b4be68&scoped=true"
import script from "./ProjectModel.vue?vue&type=script&lang=js"
export * from "./ProjectModel.vue?vue&type=script&lang=js"

import "./ProjectModel.vue?vue&type=style&index=0&id=b2b4be68&lang=scss&scoped=true"
import "./ProjectModel.vue?vue&type=style&index=1&id=b2b4be68&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2b4be68"]])

export default __exports__